// extracted by mini-css-extract-plugin
export default {"documentContent":"DocumentPage_documentContent__eIV9i"};